// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"a278e526","62":"0fe34480","109":"29a51d43","416":"9903c0ef","538":"7502cfce","566":"e5f743d4","614":"084c75c7","676":"349fe63c","978":"36bf28b4"}[chunkId] + ".chunk.js";
};